var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"height-0 width-100 mx-auto"},[_c('span',{staticClass:"headline white--text pa-2"},[_vm._v("\n    "+_vm._s(_vm.$t(("activities.reservation_types." + _vm.reservationMethodType)))+"\n  ")])])}
var staticRenderFns = []

export { render, staticRenderFns }